import headerBg from '@/assets/images/active/snail/fifth/mo/header_bg.png';
import accountBtn from '@/assets/images/active/snail/fourth/head/switch.png';
import activeBtn from '@/assets/images/active/snail/fourth/head/download.png';
export const headerConfig = {
  'zh-cn': {
    not_logged_in: {
      background_image: headerBg,
      title: '最强蜗牛',
      sub_title: '有梗有趣，还有蜗和鹂',
      style: ''
    },
    logged_in: {
      background_image: headerBg,
      main_title_color: '#755013',
      sub_title_color: '#755013',
      tips_color: '#5679d0',
      game_name: '最强蜗牛',
    },
    operation_btn: {
      office_website: {
        width: '2.3rem',
        top: '0.2rem',
        height: '',
        background_image: '',
        img: require('@/assets/images/active/snail/fifth/mo/zh/official.png'),
        link: 'https://snail.qingcigame.com/official/index_mobile.html'
      },
      login: {
        top: '0.2rem',
        width: '',
        height: '',
        background_image: '',
        img: require('@/assets/images/active/snail/fifth/mo/zh/login_btn.png'),
        style: ''
      },
      change_account: {
        top: '0.2rem',
        width: '',
        height: '',
        background_image: '',
        img: accountBtn,
        style: ''
      },
      join_active: {
        width: '',
        height: '',
        background_image: '',
        img: activeBtn,
        style: '',
        link: ''
      },
      logout: {
        top: '0.2rem',
        width: '',
        height: '',
        img: require('@/assets/images/active/snail/fifth/mo/zh/loginOut.png'),
        style: ''
      }
    }
  },
  'zh-tw': {
    not_logged_in: {
      background_image: headerBg,
      title: '最強蝸牛',
      sub_title: '有梗有趣，蝸蝸蝸呱呱呱',
      style: ''
    },
    logged_in: {
      background_image: headerBg,
      main_title_color: '#755013',
      sub_title_color: '#755013',
      tips_color: '#5679d0',
      game_name: '最強蝸牛',
    },
    operation_btn: {
      office_website: {
        width: '2.3rem',
        top: '0.2rem',
        height: '',
        background_image: '',
        img: require('@/assets/images/active/snail/fifth/hk/official.png'),
        link: 'https://snail.snell.com.tw/official/index_mobile.html'
      },
      login: {
        top: '0.2rem',
        width: '',
        height: '',
        background_image: '',
        img: require('@/assets/images/active/snail/fifth/hk/login_btn.png'),
        style: ''
      },
      change_account: {
        top: '0.2rem',
        width: '',
        height: '',
        background_image: '',
        img: accountBtn,
        style: ''
      },
      join_active: {
        width: '',
        height: '',
        background_image: '',
        img: activeBtn,
        style: '',
        link: ''
      },
      logout: {
        top: '0.2rem',
        width: '',
        height: '',
        img: require('@/assets/images/active/snail/fifth/hk/loginOut.png'),
        style: ''
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/pages/snail/5thReport/headerConfig.js